<update-password-form 
(resetpasswordFormData)="resetPasswordData($event)" 
[isPasswordUpdate]="isPwdUpdate"
[appName]="appName"
></update-password-form>